module.exports = __webpack_public_path__ + "static/beer2-706591e71c30ca81b3dd766716c580fc.jpg";